import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";

export default function PermissionCard({ branchData, student: payee }) {
  const printRef = useRef();

  const [formData, setFormData] = useState({
    name:
      [payee?.firstName, payee?.middleName, payee?.lastName]
        .filter(Boolean)
        .join(" ") ||
      payee?.vendorName ||
      payee?.name ||
      "",

    course:
      payee?.selectedCourse ||
      payee?.serviceScope ||
      "Enterprise Systems & On-Site Operations",

    examCourse: "ON-SITE INTEGRATION",
    examMonth: "DECEMBER",
    examYear: "2026",

    fromDate: "",
    toDate: "",

    date: new Date().toLocaleDateString("en-GB"),
  });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;

    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>OPERATIONAL PERMIT CARD</title>

          <style>
            body {
              font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
              padding: 40px;
              margin: 0;
              color: #222;
            }

            .header {
              width: 100%;
              text-align: center;
              margin-bottom: 20px;
            }

            .logo {
              display: block;
              width: 80px;
              margin: 0 auto 5px auto;
            }

            .title-main,
            .title-sub {
              width: 100%;
              text-align: center;
              font-weight: bold;
            }

            .title-main {
              font-size: 20px;
              letter-spacing: 0.5px;
            }

            .title-sub {
              font-size: 15px;
              margin-bottom: 20px;
            }

            .field-row {
              margin: 20px 0;
              font-size: 15px;
            }

            .label {
              display: inline-block;
              width: 220px;
              font-weight: bold;
            }

            .line {
              display: inline-block;
              border-bottom: 1px dotted #000;
              min-width: 280px;
              padding-left: 5px;
            }

            .footer {
              margin-top: 80px;
            }

            .left {
              float: left;
              font-weight: bold;
            }

            .right {
              float: right;
              font-weight: bold;
              text-align: right;
            }

            .clear {
              clear: both;
            }
          </style>
        </head>

        <body>
          ${content}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Container className="mt-4">
      {/* PRINT AREA */}
      <div ref={printRef}>
        <div className="header">
          {branchData?.logoUrl && (
            <img
              src={branchData.logoUrl}
              alt="Corporate Logo"
              className="logo"
              style={{ width: "80px" }}
            />
          )}

          <div className="title-main">GLOBAL LOGISTICS & MANUFACTURING CORP</div>

          <div className="title-sub">
            OPERATIONAL WORK PERMIT FOR {formData.examCourse}{" "}
            {formData.examMonth} {formData.examYear}
          </div>
        </div>

        <div className="field-row">
          <span className="label">OPERATOR / CONTRACTOR</span> :
          <span className="line">{formData.name}</span>
        </div>

        <div className="field-row">
          <span className="label">SERVICE / OPERATION</span> :
          <span className="line">{formData.course}</span>
        </div>

        <div className="field-row">
          <span className="label">VALID FROM</span> :
          <span className="line">{formData.fromDate}</span>

          <span style={{ marginLeft: "20px", fontWeight: "bold" }}>
            VALID UNTIL :
          </span>

          <span className="line" style={{ marginLeft: "10px" }}>
            {formData.toDate}
          </span>
        </div>

        <div className="footer">
          <div style={{ marginBottom: "50px" }}>
            Issue Date : {formData.date}
          </div>

          <div className="left">OPERATIONS CONTROLLER</div>

          <div className="right">SITE DIRECTOR</div>

          <div className="clear"></div>
        </div>
      </div>

      {/* FORM */}
      <Form className="mt-4 border-top pt-4">
        <Row className="mb-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Contractor / Person Name</Form.Label>
              <Form.Control
                placeholder="Operator / Contractor Name"
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Project Scope / Operation</Form.Label>
              <Form.Control
                placeholder="Service Scope"
                value={formData.course}
                onChange={(e) => handleChange("course", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Permit Type / Category</Form.Label>
              <Form.Control
                placeholder="Work Category"
                value={formData.examCourse}
                onChange={(e) => handleChange("examCourse", e.target.value)}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Month / Cycle</Form.Label>
              <Form.Control
                placeholder="Month"
                value={formData.examMonth}
                onChange={(e) =>
                  handleChange("examMonth", e.target.value.toUpperCase())
                }
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Year</Form.Label>
              <Form.Control
                placeholder="Year"
                value={formData.examYear}
                onChange={(e) => handleChange("examYear", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Valid From</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    handleChange(
                      "fromDate",
                      new Date(value).toLocaleDateString("en-GB")
                    );
                  }
                }}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group>
              <Form.Label>Valid Until</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    handleChange(
                      "toDate",
                      new Date(value).toLocaleDateString("en-GB")
                    );
                  }
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Issue Date</Form.Label>
              <Form.Control
                type="date"
                onChange={(e) => {
                  const value = e.target.value;
                  if (value) {
                    handleChange(
                      "date",
                      new Date(value).toLocaleDateString("en-GB")
                    );
                  }
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <Button onClick={handlePrint} className="mt-3" variant="primary">
          Print Operational Permit
        </Button>
      </Form>
    </Container>
  );
}